<template>
  <v-container fluid class="PortfolioView content-page raster">
    <page-title title="My Portfolio" icon="mdi-account"></page-title>
  </v-container>
</template>

<script>
import PageTitle from '@/components/PageTitle.vue'

export default {
  name: 'PortfolioView',
  components: { PageTitle },
}
</script>

<style scoped lang="scss">
</style>
